<template>
  <PageHeader :title="field.name || 'New Field'" :subtitle="customer.name" icon="mdi-focus-field" @subtitle="toCustomer" @back="toCustomer" back>

    <template v-slot:buttons>
      <v-btn v-if="hrContract" color="primary" small dense class="mr-1" :to="{name: 'HRContractDetail', query: { uuid: customerUuid, fieldUuid: fieldUuid } }"><v-icon dense>mdi-format-line-style</v-icon> {{$t('contract')}}</v-btn>
      <AssessButton :customer="customer" :field="field" />
      <TakePhoto @click="saveImage">
        <v-btn color="primary" small dense class="ml-1"><v-icon dense class="mr-1">mdi-camera-outline</v-icon> <span class="hidden-sm-and-down">{{$t('photo')}}</span></v-btn>
      </TakePhoto>
      <v-btn color="primary" small dense class="ml-1" :to="{name: 'MapField', query: { uuid: customerUuid, fieldUuid: fieldUuid } }"><v-icon dense>mdi-google-maps</v-icon> {{$t('Map')}}</v-btn>
      <v-btn color="primary" small dense @click="edit" :to="{name: 'FieldEdit', query: { uuid: customerUuid, fieldUuid: fieldUuid } }" class="ml-1"><v-icon dense>mdi-account-edit-outline</v-icon> {{$t('edit')}}</v-btn>
    </template>


    <template v-slot:menu>

      <AppMenuItem v-if="hrContract" icon="mdi-format-line-style" :to="{name: 'HRContractDetail', query: { uuid: customer.uuid, fieldUuid: field.uuid } }" :title="$t('contract')" />      

      <AppMenuItem icon="mdi-star-check-outline" :to="{name: assessmentForm, query: { uuid: customer.uuid, fieldUuid: field.uuid } }" :title="$t('assess')" />

      <TakePhoto  :text="$t('imageInfo')" @click="saveImage">
        <AppMenuItem icon="mdi-camera-outline" :title="$t('Take Photos')" />
      </TakePhoto>

      <AppMenuItem icon="mdi-google-maps" :to="{name: 'MapField', query: { uuid: customerUuid, fieldUuid: fieldUuid } }" :title="$t('mapField')" />
      <AppMenuItem icon="mdi-account-edit-outline" @click="edit" :title="$t('edit')" />

    </template>

    <slot></slot>

  </PageHeader>
</template>


<script>

  import PageHeader from '@/components/PageHeader'
  import TakePhoto from '@/components/TakePhoto';
  import AppMenuItem from '@/components/AppMenuItem';
  import AssessButton from '@/views/fields/components/AssessButton';

  export default {

    components: { PageHeader, TakePhoto, AppMenuItem, AssessButton },

    props: ['customer', 'field'],

    computed: {
      customerUuid() { return this.$route.query.uuid; },
      fieldUuid() { return this.$route.query.fieldUuid; },
      cropLookups() { return this.$store.getters.cropLookups; },
      partnerCode() { return this.$store.getters.partnerCode; },
      hr() { return ['hr_co', 'winwin_zw'].includes(this.partnerCode); },
      hrContract() {
        let r = this.hr;
        if (r && this.field & this.field.payload && this.field.payload['hrContractDetailAt']) {
          r = ( this.field.payload['hrContractDetailAt'] < ( new Date( new Date - 180*24*60*60000 ) ).toISOString() );
        }
        return r;
      },
      assessmentForm() {
        let f = 'FieldScore';
        if ( ['hr_co', 'winwin_zw'].includes(this.partnerCode) ) { f = 'HRFieldScore'; }
        return f;
      },
    },

    methods: {
      saveImage(uuid) { this.$store.dispatch('addImage', { type: 'field', type_id: this.fieldUuid, uuid: uuid }); },
      edit() { this.$emit('edit', true); },
      toCustomer() { this.$router.push({ name: 'ShowCustomer', query: { uuid: this.customerUuid } }); },
    }

  }

</script>


<i18n>
{
  "en": {
    "contract": "Contract",
    "assess": "Assess",
    "Take Photos": "Take Photos",
    "imageInfo": "Use your camera to take photos of the field",
    "Map": "Map",
    "mapField": "Map Field"
  },
  "es": {
    "contract": "Contrato",
    "assess": "Evaluar",
    "Take Photos": "Tomar fotos",
    "imageInfo": "Usa tu cámara para tomar fotos de los cultivos",
    "Map": "Mapa",
    "mapField": "Mapa del Lote"
  },
  "sw": {
    "contract": "Mkataba",
    "assess": "Tathmini",
    "Take Photos": "Piga Picha",
    "imageInfo": "Tumia kamera yako kuchukua picha za uwanja",
    "Map": "Ramani",
    "mapField": "Shamba la Ramani"
  }
}
</i18n>
